import type { LocationConfig } from '@shared/location-config-types';

/**
 * Babcock Ranch, Florida — location config.
 *
 * homeBase must stay in sync with HOME_LAT / HOME_LNG in wrangler.jsonc.
 * The worker uses those to compute distance_from_home_miles at read time;
 * this config drives the map's home pin. If they drift apart, the map will
 * disagree with the "N mi away" text on the same screen.
 */
export const babcockRanchConfig: LocationConfig = {
  slug: 'babcock-ranch',
  displayName: 'Babcock Ranch',
  geo: {
    // Town centroid — near Founder's Square on Lake Babcock.
    center: [26.7906, -81.7442],
    // NOTE: bounds intentionally exclude the erroneous ~26.95 "Bermont"
    // cluster that 37 place records used to sit in. If a place ever renders
    // outside these bounds again, suspect bad coordinates, not bad bounds.
    // Bounds cover the full Babcock Ranch developed footprint plus a small
    // margin so nearby regional destinations (Punta Gorda, Fort Myers) can
    // still fit on the map when the auto-fit expands.
    bounds: [
      [26.72, -81.82], // SW
      [26.86, -81.68], // NE
    ],
    homeBase: {
      // 43030 Greenway Blvd, Babcock National district. Street-level accuracy
      // from OpenStreetMap; see the note in wrangler.jsonc for why the exact
      // housenumber cannot be geocoded.
      //
      // MUST match HOME_LAT / HOME_LNG in wrangler.jsonc. The worker derives
      // every "N mi away" figure from those; this drives the map's home pin.
      // If they drift, the map contradicts the text on the same screen.
      lat: 26.798,
      lon: -81.7447,
      label: 'Our Rental',
    },
    zoomDefault: 13,
  },
};
